export default __webpack_public_path__ + "static/media/footer_image.fb98eeee.jpg";